import React from 'react';

interface ISearchIconProps {
  style?: any;
}

export const SearchIcon:React.FC<ISearchIconProps> = (props: ISearchIconProps) => {
  return (
    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" style={props.style}>
      <g>
      <title>background</title>
      <rect fill="none" id="canvas_background" height="402" width="582" y="-1" x="-1"/>
      </g>
      <g>
      <title>Layer 1</title>
      <path fill="#cccccc" id="svg_1" d="m12.9,14.32a8,8 0 1 1 1.41,-1.41l5.35,5.33l-1.42,1.42l-5.33,-5.34l-0.01,0zm-4.9,-0.32a6,6 0 1 0 0,-12a6,6 0 0 0 0,12z"/>
      </g>
    </svg>
  )
}